import Footer from 'pages/components/Footer'
import Header from 'pages/components/Header'
import React, { useState } from 'react'
import styles from './IssueMakers.module.scss'
// ㄱ
import 강동민_gray from 'static/images/members/강동민_gray.jpg'
import 강동민 from 'static/images/members/강동민.jpg'
import 권다현_gray from 'static/images/members/권다현_gray.jpg'
import 권다현 from 'static/images/members/권다현.jpg'
import 김규완_gray from 'static/images/members/김규완_gray.jpg'
import 김규완 from 'static/images/members/김규완.png'
import 김민정_gray from 'static/images/members/김민정_gray.png'
import 김민정 from 'static/images/members/김민정.png'
import 김슬기_gray from 'static/images/members/김슬기_gray.png'
import 김슬기 from 'static/images/members/김슬기.png'
import 김영웅_gray from 'static/images/members/김영웅_gray.jpg'
import 김영웅 from 'static/images/members/김영웅.jpg'
import 김진성_gray from 'static/images/members/김진성_gray.png'
import 김진성 from 'static/images/members/김진성.png'
import 김현빈_gray from 'static/images/members/김현빈_gray.jpg'
import 김현빈 from 'static/images/members/김현빈.jpg'
import 김현지_gray from 'static/images/members/김현지_gray.png'
import 김현지 from 'static/images/members/김현지.png'

// ㄴ
import 남유진_gray from 'static/images/members/남유진_gray.jpg'
import 남유진 from 'static/images/members/남유진.jpg'

// ㅂ
import 박서희_gray from 'static/images/members/박서희_gray.png'
import 박서희 from 'static/images/members/박서희.png'
import 박재현_gray from 'static/images/members/박재현_gray.jpg'
import 박재현 from 'static/images/members/박재현.jpg'

// ㅇ
import 이고은_gray from 'static/images/members/이고은_gray.jpg'
import 이고은 from 'static/images/members/이고은.jpg'
import 이소연_gray from 'static/images/members/이소연_gray.png'
import 이소연 from 'static/images/members/이소연.png'
import 이소정_gray from 'static/images/members/이소정_gray.png'
import 이소정 from 'static/images/members/이소정.png'
import 이형백_gray from 'static/images/members/이형백_gray.jpg'
import 이형백 from 'static/images/members/이형백.jpg'

// ㅈ
import 조성학_gray from 'static/images/members/조성학_gray.jpg'
import 조성학 from 'static/images/members/조성학.jpg'

// 기타
import 송민아_gray from 'static/images/members/송민아_gray.jpg'
import 송민아 from 'static/images/members/송민아.jpg'
import 조수민_gray from 'static/images/members/조수민_gray.png'
import 조수민 from 'static/images/members/조수민.png'
import 최미소_gray from 'static/images/members/최미소_gray.png'
import 최미소 from 'static/images/members/최미소.png'
import 최윤석_gray from 'static/images/members/최윤석_gray.png'
import 최윤석 from 'static/images/members/최윤석.png'

import logo from 'static/images/members/Member_logo.png'
import BackgroundImg from 'static/images/sub-img-2.png'
import Modal from 'react-modal'
import { NodeExpandOutlined } from '@ant-design/icons'

const Members = () => {
  const [visible, setVisible] = useState(false)
  const [selectedUser, setSelectedUser] = useState({})

  const showModal = ({ imgSrc, name, title, introduction, discription }) => {
    setSelectedUser({ imgSrc, name, title, introduction, discription })
    setVisible(true)
  }

  const Member = ({
    imgGreySrc,
    imgSrc,
    name,
    title,
    introduction,
    discription,
    clickHandler,
  }) => (
    <article className={styles['member']}>
      <img src={imgGreySrc} className={styles['img-grey']} />
      <img
        onClick={
          clickHandler
            ? clickHandler
            : () =>
              showModal({ imgSrc, name, title, introduction, discription })
        }
        src={imgSrc}
        className={styles['img-active']}
      />
      {name ? (
        <section className={styles['member-info']}>
          <span className={styles['name']}>{name}</span>
          <span className={styles['title']}>{title}</span>
        </section>
      ) : null}
    </article>
  )

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      padding: '0px',
      border: 'none',
      borderRadius: 'none',
    },
  }

  return (
    <>
      <article className={styles['members']}>
        <Header
          title="이슈메이커"
          discription="<span>최적의 솔루션을 제공하는</span> <span>플랜이슈의 색다른 관광컨설턴트들</span>"
          backgroundImg={BackgroundImg}
        />
        <section className={styles['contents']}>
          <Member
            imgGreySrc={김진성_gray}
            imgSrc={김진성}
            title="대표"
            name="김진성"
            introduction={`CEO / Imagineer / Gregory Kim`}
            discription={`
              <b>학력</b> - 1999 경기대학교 대학원 관광개발학 석사 졸업<br/>
              1994 경기대학교 관광개발학과 학사 졸업<br/>
              <b>경력</b> - 2012~ 현 ㈜플랜이슈 대표<br/>
              2013~2015 세종특별자치시 관광시책자문단 위원<br/>
              2011 대전 국제 푸드와인 페스티벌 개발위원<br/>
              2010 서울시 관광자문위원(관광 스토리텔링 부문)<br/>
              2006~2012 ㈜디이파트너스 이사<br/>
              1999~2005 국토연구원 국토환경연구실 연구원<br/>
              <b>분야</b> - 멀티플레이어
            `}
          />
          {/* <Member imgGreySrc={logo} imgSrc={logo} clickHandler={() => {}} /> */}
          <Member
            imgGreySrc={김현지_gray}
            imgSrc={김현지}
            title="팀장"
            name="김현지"
            introduction="Team Manager / Kim Hyunji"
            discription={`
              <b>학력</b> - 2013 서울시립대학교 조경학과 석사 졸업<br/>
              2011 전남대학교 조경학 학사 졸업<br/>
              <b>경력</b> - 2020~ 현 ㈜플랜이슈 팀장<br/>
              2018~2020 ㈜동해종합기술공사 조경레저부 과장<br/>
              2014~2017 ㈜천마이앤씨 대리<br/>
              <b>자격사항</b> - 조경기사1급<br/>
              <b>분야</b> - 조경기사, 경관사업
            `}
          />
          <Member
            imgGreySrc={이소연_gray}
            imgSrc={이소연}
            title="이사"
            name="이소연"
            introduction="Executive Director / Lee, So-Yeoun"
            discription={`
              <b>학력</b> - 2000 경기대학교 대학원 관광개발학 석사 졸업<br/>
              <b>경력</b> - 2012~ 현 ㈜플랜이슈 이사<br/>
              2009~2011 ㈜다음레저 과장<br/>
              1996~1998 한일합섬 레저기획부<br/>
              1998 충청북도 단양군 관광자문 위원<br/>
              <b>분야</b> - 인사 및 재무관리
            `}
          />
          <Member
            imgGreySrc={김민정_gray}
            imgSrc={김민정}
            title="실장"
            name="김민정"
            introduction="Chief Manager / Kim Min Jung"
            discription={`
              <b>학력</b> - 2002 경희대학교 대학원 조경학전공 석사 수료<br/>
              2000 경희대학교 조경학 학사 졸업<br/>
              <b>경력</b> - 2020~ 현 ㈜플랜이슈 실장<br/>
              2019~2020 ㈜한종 레저조경부 부장<br/>
              2016~2019 ㈜예당엔지니어링 조경부 부장<br/>
              2015~2016 강산어소시에이트 조경부 차장<br/>
              2010~2012 ㈜동해종합기술공사 차장<br/>
              <b>자격사항</b> - 조경기사1급<br/>
              <b>분야</b> - 조경기사, 관광법규
            `}
          />
          <Member
            imgGreySrc={이고은_gray}
            imgSrc={이고은}
            title="주임"
            name="이고은"
            introduction="Assit. Manager / Goeun Lee"
            discription={`
              <b>학력</b> - 2024 경기대학교 관광개발학 학사 졸업<br/>
              <b>경력</b> - 2023~ 현 ㈜플랜이슈 주임<br/>
              <b>분야</b> - 관광개발, 관광 빅데이터
            `}
          />
          {/* <Member imgGreySrc={logo} imgSrc={logo} clickHandler={() => {}} /> */}
          <Member
            imgGreySrc={조수민_gray}
            imgSrc={조수민}
            title="대리"
            name="조수민"
            introduction="Assit. Manager / Sumin Jo"
            discription={`
              <b>학력</b> - 2022 경기대학교 관광개발학 학사 졸업<br/>
              <b>경력</b> - 2021~ 현 ㈜플랜이슈 대리<br/>
              2020 KBO 공식기록원 인턴<br/>
              <b>분야</b> - 관광개발, 스포츠관광
            `}
          />
          <Member
            imgGreySrc={송민아_gray}
            imgSrc={송민아}
            title="대리"
            name="송민아"
            introduction="Assit. Manager / Mina Song"
            discription={`
              <b>학력</b> - 2024 신구대학교 환경조경학 학사 졸업<br/>
              <b>경력</b> - 2023~ 현 ㈜플랜이슈 대리<br/>
              <b>분야</b> - 엔지니어링, 마스터플랜
            `}
          />
          {/* <Member imgGreySrc={logo} imgSrc={logo} clickHandler={() => {}} /> */}
          <Member
            imgGreySrc={김슬기_gray}
            imgSrc={김슬기}
            title="팀장"
            name="김슬기"
            introduction="Team Manager / Kim, Seul-Ki"
            discription={`
              <b>학력</b> - 2019 단국대학교 커뮤니케이션학부 광고홍보 학사 졸업<br/>
              <b>경력</b> - 2020~ 현 ㈜플랜이슈 팀장<br/>
              2019 ㈜커뮤니크 PR&Digital 사원<br/>
              2016~2018 ㈜플랜이슈 사원<br/>
              <b>분야</b> - 광고홍보, 스토리텔링
            `}
          />
          <Member
            imgGreySrc={최윤석_gray}
            imgSrc={최윤석}
            title="팀장"
            name="최윤석"
            introduction="Team Manager / Choi Yoonseok"
            discription={`
              <b>학력</b> - Samsung Art & Design Institute Communication Design 중퇴<br/>
              <b>경력</b> - 2019~ 현 ㈜플랜이슈 팀장<br/>
              2017~2018 CJ E&M tvN 로케이션 매니저<br/>
              2010~2017 피스마켓 대표<br/>
              2009~2010 (사)국제시각교류협회 캔파운데이션 객원디자이너<br/>
              2008~2009 토탈미술관 객원디자이너<br/>
              2004~2005 BlindSound Designers Party 객원디자이너<br/>
              2003~2010 Fletcher Syndrom 실장<br/>
              2001~2003 Design Crue 팀장<br/>
              <b>분야</b> - 시각 디자인, 브랜딩            
            `}
          />
          <Member
            imgGreySrc={박서희_gray}
            imgSrc={박서희}
            title="이사"
            name="박서희"
            introduction="Executive Director / Park, Seo-Hee"
            discription={`
              <b>학력</b> - 2003 경기대학교 관광개발학 학사 졸업<br/>
              <b>경력</b> - 2017~ 현 ㈜플랜이슈 이사<br/>
              2013~2014 ㈜흥일 사업기획팀 대리<br/>
              2012~2013 (유)청심그룹 사업기획팀 대리<br/>
              2007~2012 ㈜디이파트너스 컨설팅팀 팀장<br/>
              <b>분야</b> - 사업 타당성, 단지계획
            `}
          />
          <Member
            imgGreySrc={이소정_gray}
            imgSrc={이소정}
            title="과장"
            name="이소정"
            introduction="General Manager / Sojeong Lee"
            discription={`
              <b>학력</b> - 2022 한양대학교 대학원 관광학 석사 졸업<br/>
              <b>경력</b> - 2022~ 현 ㈜플랜이슈 과장<br/>
              2020~2022 한양대학교 관광연구소 연구원<br/>
              <b>분야</b> - 관광레저, 축제이벤트
            `}
          />
          <Member
            imgGreySrc={이형백_gray}
            imgSrc={이형백}
            title="대리"
            name="이형백"
            introduction="Assit. Manager / Hyeong Baek Lee"
            discription={`
              <b>학력</b> - 2023 경기대학교 일반대학원 여가관광개발학 석사 졸업<br/>
              <b>경력</b> - 2023~ 현 ㈜플랜이슈 대리<br/>
              <b>분야</b> - 관광개발, 체험관광
            `}
          />
          <Member
            imgGreySrc={남유진_gray}
            imgSrc={남유진}
            title="주임"
            name="남유진"
            introduction="Assit. Manager / Yujin Nam"
            discription={`
              <b>학력</b> - 2025 경기대학교 관광개발학 학사 졸업<br/>
              <b>경력</b> - 2024~ 현 ㈜플랜이슈 주임<br/>
              <b>분야</b> - 지역관광개발, 빅데이터분석
            `}
          />
          <Member
            imgGreySrc={권다현_gray}
            imgSrc={권다현}
            title="팀장"
            name="권다현"
            introduction="Team Manager / Da Hyun Kwon"
            discription={`
              <b>학력</b> - 2025~ 경희대학교 일반대학원 문화관광콘텐츠학과 박사과정<br/>
              2004 중앙대학교 문예창작학과 학사<br/>
              <b>경력</b> - 2025~ 현 (주)플랜이슈 팀장<br/>
              2023~ 문화체육관광부 문화관광축제 평가위원<br/>
              2023~ (사)한국의길과문화 이사<br/>
              2014~2015 (사)한국여행작가협회 홍보이사<br/>
              2014 한국관광의 별 단행본 부문 대상<br/>
              <b>저서</b> - <내일로 기차로>, <서울여행코스 101>, <나홀로 진짜여행>, <아이여행가이드북> 등 10여 권<br/>
              <b>분야</b> - 관광콘텐츠, 스토리텔링, 문화관광축제
            `}
          />
          <Member
            imgGreySrc={강동민_gray}
            imgSrc={강동민}
            title="팀장"
            name="강동민"
            introduction="Team Manager / Kang Dong Min"
            discription={`
              <b>학력</b> - 2017 경희대학교 스마트관광원 관광학 박사 수료<br/>
              2017 동명대학교 대학원 관광학 석사 졸업<br/>
              2015 동명대학교 경영학 학사 졸업<br/>
              <b>경력</b> - 2024~ 현 ㈜플랜이슈 팀장<br/>
              2018~2024 (재)한국산업개발연구원<br/>
              2017~2017 ㈜명소IMC 지역관광사업부 인턴<br/>
              <b>분야</b> - 지역개발, 관광특구, 빅데이터
            `}
          />
          <Member
            imgGreySrc={김규완_gray}
            imgSrc={김규완}
            title="대리"
            name="김규완"
            introduction="Assit. Manager / GyuWan Kim"
            discription={`
              <b>학력</b> - 2020 경기대학교 관광이벤트국제회의학 관광학 석사<br/>
              2015 경기대학교 정치학사<br/>
              <b>경력</b> - 2024~ 현 (주)플랜이슈 대리<br/>
              2023~2024 큐브커뮤니케이션(주) 과장<br/>
              2021 (주)아이캔컴퍼니 대리<br/>
              2015~2018 육군21사단 정훈공보장교<br/>
              <b>분야</b> - 관광개발, 지역축제 및 이벤트
            `}
          />
          <Member
            imgGreySrc={조성학_gray}
            imgSrc={조성학}
            title="실장"
            name="조성학"
            introduction="Chief Manager / SungHak Joe"
            discription={`
              <b>학력</b> - 2007 서경대학교 대학원 도시공학 석사 졸업<br/>
              2005 서경대학교 도시공학과 학사 졸업<br/>
              <b>경력</b> - 2025~ 현 ㈜플랜이슈 실장<br/>
              2007~2025 (재)한국산업개발연구원 연구위원<br/>
              <b>분야</b> - 지역개발계획, 사업 타당성
            `}
          />
          <Member
            imgGreySrc={박재현_gray}
            imgSrc={박재현}
            title="대리"
            name="박재현"
            introduction="Assit. Manager / Jaehyun Park"
            discription={`
              <b>학력</b> - 2025 중앙대학교 대학원 문화예술경영학 박사 수료<br/>
              2022 중앙대학교 대학원 문화예술경영학 석사 졸업<br/>
              2020 중앙대학교 음악악부 학사 졸업<br/>
              <b>경력</b> - 2025~ 현 ㈜플랜이슈 대리<br/>
              2022~2025 한국문화관광연구원 위촉연구원<br/>
              <b>분야</b> - 타당성, 계량분석, 문화정책
            `}
          />
          <Member
            imgGreySrc={최미소_gray}
            imgSrc={최미소}
            title="사원 "
            name="최미소"
            introduction="Staff / Miso Choi"
            discription={`
              <b>학력</b> - 2023 안양대학교 관광경영학 학사 졸업<br/>
              <b>경력</b> - 2025~ 현 ㈜플랜이슈 사원<br/>
              <b>분야</b> - 관광빅데이터 분석, 관광경영
            `}
          />
          <Member
            imgGreySrc={김현빈_gray}
            imgSrc={김현빈}
            title="사원"
            name="김현빈"
            introduction="Staff / Hyeonbin Kim"
            discription={`
              <b>학력</b> - 2024 가천대학교 실내건축학과 학사 졸업<br/>
              <b>경력</b> - 2025~ 현 ㈜플랜이슈 사원<br/>
              <b>분야</b> - 지역관광개발
            `}
          />
          <Member
            imgGreySrc={김영웅_gray}
            imgSrc={김영웅}
            title="사원"
            name="김영웅"
            introduction="Staff / YeongUng Kim"
            discription={`
              <b>학력</b> - 2025 가천대학교 관광경영학 학사 졸업 예정<br/>
              <b>경력</b> - 2025~ 현 ㈜플랜이슈 사원<br/>
              <b>분야</b> - 관광개발, 관광 빅데이터 분석
            `}
          />
        </section>
        <Modal isOpen={visible} style={customStyles}>
          <article className={styles['modal']}>
            <section className={styles['modal-content']}>
              <div className={styles['modal-img-container']}>
                <img
                  src={selectedUser.imgSrc}
                  className={styles['modal-img']}
                />
              </div>
              <section className={styles['modal-content-right']}>
                <div
                  className={styles['close-button']}
                  onClick={() => setVisible(false)}
                ></div>
                <section className={styles['modal-right-content']}>
                  <div>
                    <div className={styles['member-name-title']}>
                      <span className={styles['member-name']}>
                        {selectedUser.name}
                      </span>
                      <span className={styles['member-title']}>
                        {selectedUser.title}
                      </span>
                    </div>
                    <section className={styles['introduction']}>
                      {selectedUser.introduction}
                    </section>
                    <section
                      className={styles['discription']}
                      dangerouslySetInnerHTML={{
                        __html: selectedUser.discription,
                      }}
                    ></section>
                  </div>
                </section>
              </section>
            </section>
          </article>
        </Modal>
      </article>
      <Footer />
    </>
  )
}

export default Members
